import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/system";
import Navbar from "../../components/Navbar/Navbar";
import { Stack, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import logoImg from "../../residenzaStoricaAssets/1811white.png";
const StyledTypography = styled(Typography)({
  color: "white",
});

type Props = {
  children?: string;
};

interface ListItemProps {
  text: string;
  noWrap?: boolean;
  small?: boolean;
}

const Footer = (props: Props) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  const ListItemWithWhiteText: React.FC<ListItemProps> = ({ text, noWrap, small }) => {
    let link = "";

    if (text.startsWith("+39")) {
      // Se il testo inizia con +39, creiamo un link per fare una chiamata
      link = `tel:${text}`;
    } else if (text.startsWith("info")) {
      // Se il testo inizia con info, lo trattiamo come un'email
      // Aggiungi due destinatari separati da una virgola
      link = `mailto:info@residenzastorica.it`;
    } else if (text.toLowerCase().startsWith("via")) {
      // Se il testo inizia con "via", lo trattiamo come un indirizzo
      // Creiamo un link per Google Maps con l'indirizzo
      const address = text.slice(3).trim(); // Rimuoviamo "via" e gli spazi in eccesso
      link = `https://www.google.com/maps?q=${encodeURIComponent(address)}`;
    }
    return (
      <li>
        <StyledTypography
          sx={{
            padding: isMobile ? "5px 25px" : undefined,
            fontSize: small ? "12px" : "14px",
            color: "#fff", // Colore del testo bianco
            textAlign: isMobile ? "center" : undefined,
            fontFamily: "ivymode",
            letterSpacing: "2px",
            whiteSpace: noWrap ? "nowrap" : "normal",
          }}
          variant="body1"
        >
          {link ? (
            <a
              target="_blank"
              href={link}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {text}
            </a>
          ) : (
            text
          )}
        </StyledTypography>
      </li>
    );
  };

  return (
    <Stack
      sx={{
        zIndex: 2,
        alignItems: "center",
        p: 6,
        width: isMobile ? "100vw" : "100%",
        pb: isMobile ? 12 : undefined,
        display: "flex",
        position: "relative",
        backgroundColor: "#33414C",
      }}
    >
      <div id="footer" />
      <Grid container spacing={4}>
        <Grid item xs={12} sm={12} md={isMobile ? 12 : 2}>
          <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
            <img
              src={logoImg}
              alt={t("footer.logoAltText")}
              style={{ maxWidth: "100%", maxHeight: "200px" }}
            />
          </Box>
        </Grid>
        {isMobile ? null : (
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              sx={{
                textAlign: isMobile ? "center" : undefined,
                color: "white",
              }}
              variant="h4"
              fontFamily={"ivymode"}
            >
              Follow Us
            </Typography>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
              <li>
                <a
                  href="https://www.instagram.com/1811_residenza_storica/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    color: "inherit",
                    cursor: "pointer",
                  }}
                >
                  <ListItemWithWhiteText text="Instagram" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <ListItemWithWhiteText text="Facebook" />
                </a>
              </li>
              <li>
                <a
                  href="https://www.twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <ListItemWithWhiteText text="Twitter" />
                </a>
              </li>
            </ul>
          </Grid>
        )}
        <Grid item xs={12} sm={6} md={isMobile ? 12 : 3}>
          <Typography
            sx={{
              textAlign: isMobile ? "center" : undefined,
              color: "white",
            }}
            variant="h4"
            fontFamily={"ivymode"}
          >
            {t("footer.explore")}
          </Typography>
          <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
            <Navbar isFooter />
          </ul>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={isMobile ? 12 : 4}
          sx={{ mt: isMobile ? 4 : 0 }}
        >
          <Typography
            sx={{
              textAlign: isMobile ? "center" : undefined,
              color: "white",
            }}
            variant="h4"
            fontFamily={"ivymode"}
          >
            {t("footer.contacts")}
          </Typography>
          <Grid
            container
            columnSpacing={isMobile ? 2 : 8}
            rowSpacing={2}
            sx={{ mt: 0.5 }}
          >
            <Grid item xs={12} md={6}>
              <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
                <ListItemWithWhiteText text="info@residenzastorica.it" />
                <ListItemWithWhiteText text="+39 333 4262683" />
                <ListItemWithWhiteText text="Via Concezione a Monte Calvario 48, Napoli " />
              </ul>
            </Grid>
            <Grid item xs={12} md={6} sx={{ pl: isMobile ? 0 : 2 }}>
              <ul style={{ listStyleType: "none", paddingLeft: 0, margin: 0 }}>
              <ListItemWithWhiteText text="Pirhome srl semplificata" noWrap small />
                <ListItemWithWhiteText text="Partita IVA: IT09744531212" small />
                <ListItemWithWhiteText text="CIN: IT063049B46EEI7AQZ" small />
                <ListItemWithWhiteText text="CUSR: 15063049EXT2151" small />
              </ul>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Stack>
  );
};

export default Footer;
